import { useQuery } from '@tanstack/react-query';
import { getDefaultOrganizer } from '../api';

export const useGetDefaultOrganizerQuery = (organizationId: string) => {
    return useQuery({
        queryKey: ['organizer-id', organizationId],
        queryFn: () => getDefaultOrganizer(organizationId),
    });
};
